module.exports = __webpack_public_path__ + "img/img2.b2980999.jpg";